import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`grid auto-cols-auto grid-flow-col-dense gap-x-4 justify-center items-center`}
`

export const LocationBadge = styled.div`
  display: block;

  svg {
    width: 56px;
    height: 32px;

    @media (min-width: 36rem) {
      width: 67px;
      height: 38px;
    }
  }
`
